import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p>
                Welcome to Trademark Upgrades. By accessing or using our website and services, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services. These Terms constitute a legally binding agreement between you and Trademark Upgrades.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description of Services</h2>
              <p className="mb-4">
                Trademark Upgrades provides intellectual property services, including but not limited to:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Trademark registration services</li>
                <li>Copyright registration services</li>
                <li>Company formation services</li>
                <li>Trademark search services</li>
                <li>Amazon Brand Registry assistance</li>
                <li>Intellectual property consulting and advisory services</li>
              </ul>
              <p className="mt-4">
                We reserve the right to modify, suspend, or discontinue any aspect of our services at any time without prior notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Responsibilities</h2>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.1 Accurate Information</h3>
              <p className="mb-4">
                You agree to provide accurate, complete, and current information when using our services. You are responsible for maintaining the accuracy of your account information and for all activities that occur under your account.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.2 Lawful Use</h3>
              <p className="mb-4">You agree to use our services only for lawful purposes and in compliance with all applicable laws and regulations. You shall not:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide false or misleading information</li>
                <li>Attempt to register trademarks that infringe upon others' rights</li>
                <li>Use our services to engage in fraudulent activities</li>
                <li>Violate any intellectual property rights</li>
                <li>Interfere with or disrupt our services or servers</li>
                <li>Attempt to gain unauthorized access to any part of our services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Attorney-Client Relationship</h2>
              <p>
                By using our services, an attorney-client relationship is established between you and the attorneys at Trademark Upgrades. This relationship is subject to professional rules of conduct and confidentiality obligations. All communications between you and our attorneys are protected by attorney-client privilege to the extent permitted by law.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Fees and Payment</h2>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">5.1 Service Fees</h3>
              <p className="mb-4">
                Our service fees are clearly stated on our website and in any service agreements. Fees are subject to change, but any changes will not affect services already purchased. In addition to our service fees, you are responsible for all government filing fees and third-party costs.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">5.2 Payment Terms</h3>
              <p className="mb-4">
                Payment is typically required upfront before services are rendered. We accept various payment methods as indicated on our website. All payments are processed securely through third-party payment processors.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">5.3 Refund Policy</h3>
              <p>
                Due to the nature of our services and the work involved, refunds are generally not available once work has commenced. However, we will consider refund requests on a case-by-case basis for services not yet rendered. Government filing fees are non-refundable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. No Guarantee of Results</h2>
              <p>
                While we strive to provide excellent service and have a high success rate, we cannot guarantee specific outcomes or results. Trademark registration is subject to approval by the United States Patent and Trademark Office (USPTO), and we cannot control their decisions. The USPTO may reject applications for various reasons, including likelihood of confusion with existing marks or descriptiveness issues.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Intellectual Property Rights</h2>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">7.1 Our Content</h3>
              <p className="mb-4">
                All content on our website, including text, graphics, logos, images, and software, is the property of Trademark Upgrades or its licensors and is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, modify, or create derivative works from our content without our express written permission.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">7.2 Your Content</h3>
              <p>
                By submitting information, materials, or content to us, you grant us a non-exclusive, royalty-free license to use such content as necessary to provide our services. You retain ownership of your content and intellectual property rights.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Confidentiality</h2>
              <p>
                We maintain strict confidentiality regarding all client information and communications. We will not disclose your confidential information to third parties except as necessary to provide our services, as required by law, or with your consent. This obligation of confidentiality survives termination of our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Limitation of Liability</h2>
              <p className="mb-4">
                To the fullest extent permitted by law, Trademark Upgrades and its officers, directors, employees, and agents shall not be liable for:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Any indirect, incidental, special, consequential, or punitive damages</li>
                <li>Loss of profits, revenue, data, or business opportunities</li>
                <li>Decisions made by government agencies (e.g., USPTO)</li>
                <li>Delays or failures in service delivery due to circumstances beyond our control</li>
              </ul>
              <p className="mt-4">
                Our total liability to you for any claims arising from our services shall not exceed the amount you paid us for those services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Indemnification</h2>
              <p>
                You agree to indemnify, defend, and hold harmless Trademark Upgrades and its affiliates, officers, directors, employees, and agents from any claims, liabilities, damages, losses, costs, or expenses (including reasonable attorneys' fees) arising from your use of our services, violation of these Terms, or infringement of any third-party rights.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Dispute Resolution</h2>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">11.1 Governing Law</h3>
              <p className="mb-4">
                These Terms shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of law provisions.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">11.2 Arbitration</h3>
              <p className="mb-4">
                Any dispute arising from these Terms or our services shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. The arbitration shall take place in San Francisco, CA. Each party shall bear its own costs and expenses.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">11.3 Class Action Waiver</h3>
              <p>
                You agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a class, consolidated, or representative action.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Termination</h2>
              <p>
                Either party may terminate the service relationship at any time with written notice. Upon termination, you remain responsible for any fees owed for services already provided. We reserve the right to suspend or terminate your access to our services if you violate these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. We will notify you of material changes by posting the updated Terms on our website with a new "Last Updated" date. Your continued use of our services after such changes constitutes acceptance of the modified Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Severability</h2>
              <p>
                If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect. The invalid provision shall be replaced with a valid provision that most closely reflects the original intent.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">15. Entire Agreement</h2>
              <p>
                These Terms, together with our Privacy Policy and any service agreements, constitute the entire agreement between you and Trademark Upgrades regarding the use of our services and supersede all prior agreements and understandings.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">16. Contact Information</h2>
              <p className="mb-4">
                If you have any questions or concerns about these Terms of Service, please contact us:
              </p>
              <Card className="bg-orange-50 border-orange-200">
                <CardContent className="pt-6">
                  <p className="font-semibold text-gray-900 mb-2">Trademark Upgrades</p>
                  <p className="text-gray-700">Email: legal@trademarkupgrades.com</p>
                  <p className="text-gray-700">Phone: +1 (877) 545 4635</p>
                  <p className="text-gray-700">Address: 11811 North Freeway Suite 222, Houston, TX 77060</p>
                </CardContent>
              </Card>
            </section>

            <section className="border-t pt-8 mt-8">
              <p className="text-sm text-gray-600">
                By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
